import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {ButtonThemeEnum} from "../button/button-theme-enum";
import {ToastService} from "../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";

@Component({
  selector: 'yo-number-box',
  templateUrl: './number-box.component.html',
  styleUrls: ['./number-box.component.scss'],
  standalone: false
})
export class NumberBoxComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Input() value: number;
  @Input() min: number;
  @Input() max: number;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;

  /**
   * Permet de rendre le texte non lisible lors de l'écriture / lecture
   */
  @Input() secret: boolean = false;

  /**
   * Permet d'afficher le bouton de copie dans le presse-papier
   */
  @Input() copy: boolean = false;

  /**
   * Nom de la propriété à se baser pour l'autocompletion
   */
  @Input() autoComplete: string = "off";

  @Output() onValueChanged = new EventEmitter();

  constructor(private toastSvc: ToastService) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  onChange($event) {
    this.value = $event.target.value;
    this.onValueChanged.emit(this.value);
  }
}
